module.exports = __webpack_public_path__ + "img/Hand_farbig.21c94a2.svg";